import React from "react";

const SelectBox = ({ selectLists, handleSelectBox, handleSelectBoxName }) => {
  const handleChangeSelect = (e) => {
    const selectedId = e.target.value;

    const selectedName = selectLists.filter((e) => {
      return selectedId === e.fourthSeq.empId;
    });
    handleSelectBox(selectedId);
    handleSelectBoxName(selectedName[0].EMP_NM);
  };

  return (
    <>
      <select onChange={handleChangeSelect}>
        {selectLists.map((options) => (
          <option key={options.EMP_EMAIL} value={options.fourthSeq.empId}>
            {options.EMP_NM}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectBox;
